export default __webpack_public_path__ + "static/media/regulatory--end-of-school-zone--g1.f865537a.png";